module.exports = __webpack_public_path__ + "img/galeria-video-2.a4c33e23.png";